'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var index$3 = require('./want-manager/index.js');

var network = require('./network.js');

var index$2 = require('./decision-engine/index.js');

var notifications = require('./notifications.js');

var index = require('./utils/index.js');

var index$1 = require('./stats/index.js');

var nativeAbortController = require('native-abort-controller');

var anySignal = require('any-signal');

var base = require('blockstore-core/base');

var cid = require('multiformats/cid');

var defaultOptions = {
  statsEnabled: false,
  statsComputeThrottleTimeout: 1000,
  statsComputeThrottleMaxQueueSize: 1000
};
var statsKeys = ['blocksReceived', 'dataReceived', 'dupBlksReceived', 'dupDataReceived', 'blocksSent', 'dataSent', 'providesBufferLength', 'wantListLength', 'peerCount'];

var Bitswap = /*#__PURE__*/function (_base$BaseBlockstore) {
  _inherits(Bitswap, _base$BaseBlockstore);

  var _super = _createSuper(Bitswap);

  function Bitswap(libp2p, blockstore) {
    var _this3;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Bitswap);

    _this3 = _super.call(this);
    _this3._libp2p = libp2p;
    _this3._log = index.logger(_this3.peerId);
    _this3._options = Object.assign({}, defaultOptions, options);
    _this3._stats = new index$1.Stats(statsKeys, {
      enabled: _this3._options.statsEnabled,
      computeThrottleTimeout: _this3._options.statsComputeThrottleTimeout,
      computeThrottleMaxQueueSize: _this3._options.statsComputeThrottleMaxQueueSize
    });
    _this3.network = new network.Network(libp2p, _assertThisInitialized(_this3), _this3._stats, {
      hashLoader: options.hashLoader
    });
    _this3.blockstore = blockstore;
    _this3.engine = new index$2.DecisionEngine(_this3.peerId, blockstore, _this3.network, _this3._stats);
    _this3.wm = new index$3.WantManager(_this3.peerId, _this3.network, _this3._stats);
    _this3.notifications = new notifications.Notifications(_this3.peerId);
    _this3.started = false;
    return _this3;
  }

  _createClass(Bitswap, [{
    key: "isStarted",
    value: function isStarted() {
      return this.started;
    }
  }, {
    key: "peerId",
    get: function get() {
      return this._libp2p.peerId;
    }
  }, {
    key: "_receiveMessage",
    value: function () {
      var _receiveMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, incoming) {
        var _this4 = this;

        var received, _iterator3, _step3, _step3$value, cidStr, data, cid$1;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.engine.messageReceived(peerId, incoming);

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                this._log('failed to receive message', incoming);

              case 8:
                if (!(incoming.blocks.size === 0)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                received = [];
                _iterator3 = _createForOfIteratorHelper(incoming.blocks.entries());

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _step3$value = _slicedToArray(_step3.value, 2), cidStr = _step3$value[0], data = _step3$value[1];
                    cid$1 = cid.CID.parse(cidStr);
                    received.push({
                      wasWanted: this.wm.wantlist.contains(cid$1),
                      cid: cid$1,
                      data: data
                    });
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                this.wm.cancelWants(received.filter(function (_ref) {
                  var wasWanted = _ref.wasWanted;
                  return wasWanted;
                }).map(function (_ref2) {
                  var cid = _ref2.cid;
                  return cid;
                }));
                _context.next = 16;
                return Promise.all(received.map(function (_ref3) {
                  var cid = _ref3.cid,
                      wasWanted = _ref3.wasWanted,
                      data = _ref3.data;
                  return _this4._handleReceivedBlock(peerId, cid, data, wasWanted);
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function _receiveMessage(_x, _x2) {
        return _receiveMessage2.apply(this, arguments);
      }

      return _receiveMessage;
    }()
  }, {
    key: "_handleReceivedBlock",
    value: function () {
      var _handleReceivedBlock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerId, cid, data, wasWanted) {
        var has;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._log('received block');

                _context2.next = 3;
                return this.blockstore.has(cid);

              case 3:
                has = _context2.sent;

                this._updateReceiveCounters(peerId.toB58String(), cid, data, has);

                if (wasWanted) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _context2.next = 9;
                return this.put(cid, data);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _handleReceivedBlock(_x3, _x4, _x5, _x6) {
        return _handleReceivedBlock2.apply(this, arguments);
      }

      return _handleReceivedBlock;
    }()
  }, {
    key: "_updateReceiveCounters",
    value: function _updateReceiveCounters(peerIdStr, cid, data, exists) {
      this._stats.push(peerIdStr, 'blocksReceived', 1);

      this._stats.push(peerIdStr, 'dataReceived', data.length);

      if (exists) {
        this._stats.push(peerIdStr, 'dupBlksReceived', 1);

        this._stats.push(peerIdStr, 'dupDataReceived', data.length);
      }
    }
  }, {
    key: "_receiveError",
    value: function _receiveError(err) {
      this._log.error('ReceiveError: %s', err.message);
    }
  }, {
    key: "_onPeerConnected",
    value: function _onPeerConnected(peerId) {
      this.wm.connected(peerId);
    }
  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(peerId) {
      this.wm.disconnected(peerId);
      this.engine.peerDisconnected(peerId);

      this._stats.disconnected(peerId);
    }
  }, {
    key: "enableStats",
    value: function enableStats() {
      this._stats.enable();
    }
  }, {
    key: "disableStats",
    value: function disableStats() {
      this._stats.disable();
    }
  }, {
    key: "wantlistForPeer",
    value: function wantlistForPeer(peerId, _options) {
      return this.engine.wantlistForPeer(peerId);
    }
  }, {
    key: "ledgerForPeer",
    value: function ledgerForPeer(peerId) {
      return this.engine.ledgerForPeer(peerId);
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid) {
        var _this5 = this;

        var options,
            fetchFromNetwork,
            promptedNetwork,
            loadOrFetchFromNetwork,
            controller,
            signal,
            block,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                fetchFromNetwork = function fetchFromNetwork(cid, options) {
                  _this5.wm.wantBlocks([cid], options);

                  return _this5.notifications.wantBlock(cid, options);
                };

                promptedNetwork = false;

                loadOrFetchFromNetwork = /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid, options) {
                    var _block;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _this5.blockstore.get(cid, options);

                          case 3:
                            _block = _context3.sent;
                            return _context3.abrupt("return", _block);

                          case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3["catch"](0);

                            if (!(_context3.t0.code !== 'ERR_NOT_FOUND')) {
                              _context3.next = 11;
                              break;
                            }

                            throw _context3.t0;

                          case 11:
                            if (!promptedNetwork) {
                              promptedNetwork = true;

                              _this5.network.findAndConnect(cid).catch(function (err) {
                                return _this5._log.error(err);
                              });
                            }

                            return _context3.abrupt("return", fetchFromNetwork(cid, options));

                          case 13:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[0, 7]]);
                  }));

                  return function loadOrFetchFromNetwork(_x8, _x9) {
                    return _ref4.apply(this, arguments);
                  };
                }();

                controller = new nativeAbortController.AbortController();
                signal = options.signal ? anySignal.anySignal([options.signal, controller.signal]) : controller.signal;
                _context4.next = 8;
                return Promise.race([this.notifications.wantBlock(cid, {
                  signal: signal
                }), loadOrFetchFromNetwork(cid, {
                  signal: signal
                })]);

              case 8:
                block = _context4.sent;
                controller.abort();
                return _context4.abrupt("return", block);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function get(_x7) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getMany",
    value: function getMany(cids) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context5.prev = 2;
                _iterator = _asyncIterator(cids);

              case 4:
                _context5.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context5.sent).done)) {
                  _context5.next = 13;
                  break;
                }

                _cid = _step.value;
                _context5.next = 10;
                return _this.get(_cid, options);

              case 10:
                _iteratorAbruptCompletion = false;
                _context5.next = 4;
                break;

              case 13:
                _context5.next = 19;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context5.t0;

              case 19:
                _context5.prev = 19;
                _context5.prev = 20;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 24;
                return _awaitAsyncGenerator(_iterator.return());

              case 24:
                _context5.prev = 24;

                if (!_didIteratorError) {
                  _context5.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context5.finish(24);

              case 28:
                return _context5.finish(19);

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "unwant",
    value: function unwant(cids) {
      var _this6 = this;

      var cidsArray = Array.isArray(cids) ? cids : [cids];
      this.wm.unwantBlocks(cidsArray);
      cidsArray.forEach(function (cid) {
        return _this6.notifications.unwantBlock(cid);
      });
    }
  }, {
    key: "cancelWants",
    value: function cancelWants(cids) {
      this.wm.cancelWants(Array.isArray(cids) ? cids : [cids]);
    }
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cid, block, _options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.blockstore.put(cid, block);

              case 2:
                this._sendHaveBlockNotifications(cid, block);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function put(_x10, _x11, _x12) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "putMany",
    value: function putMany(source, options) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, key, value;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context7.prev = 2;
                _iterator2 = _asyncIterator(_this2.blockstore.putMany(source, options));

              case 4:
                _context7.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context7.sent).done)) {
                  _context7.next = 14;
                  break;
                }

                _step2$value = _step2.value, key = _step2$value.key, value = _step2$value.value;

                _this2._sendHaveBlockNotifications(key, value);

                _context7.next = 11;
                return {
                  key: key,
                  value: value
                };

              case 11:
                _iteratorAbruptCompletion2 = false;
                _context7.next = 4;
                break;

              case 14:
                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context7.t0;

              case 20:
                _context7.prev = 20;
                _context7.prev = 21;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 25;
                return _awaitAsyncGenerator(_iterator2.return());

              case 25:
                _context7.prev = 25;

                if (!_didIteratorError2) {
                  _context7.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context7.finish(25);

              case 29:
                return _context7.finish(20);

              case 30:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 16, 20, 30], [21,, 25, 29]]);
      }))();
    }
  }, {
    key: "_sendHaveBlockNotifications",
    value: function _sendHaveBlockNotifications(cid, data) {
      var _this7 = this;

      this.notifications.hasBlock(cid, data);
      this.engine.receivedBlocks([{
        cid: cid,
        data: data
      }]);
      this.network.provide(cid).catch(function (err) {
        _this7._log.error('Failed to provide: %s', err.message);
      });
    }
  }, {
    key: "getWantlist",
    value: function getWantlist() {
      return this.wm.wantlist.entries();
    }
  }, {
    key: "peers",
    value: function peers() {
      return this.engine.peers();
    }
  }, {
    key: "stat",
    value: function stat() {
      return this._stats;
    }
  }, {
    key: "start",
    value: function start() {
      this.wm.start();
      this.network.start();
      this.engine.start();
      this.started = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this._stats.stop();

      this.wm.stop();
      this.network.stop();
      this.engine.stop();
      this.started = false;
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this.blockstore;
    }
  }]);

  return Bitswap;
}(base.BaseBlockstore);

exports.Bitswap = Bitswap;